/* eslint-disable @typescript-eslint/no-explicit-any */

import { Card, Input, InputNumber } from "antd";

export default function LineItems(props: any) {
  const { inputData, color, setInputData } = props;
  return (
    <Card
      className={`${color} estimateServicesList`}
      style={{ cursor: "pointer" }}
    >
      <div className="top_wrap" style={{ margin: 0 }}>
        <div className="top_wrap_left">
          <h4>
            <Input
              type="text"
              onChange={(e) => {
                const newName = e.target.value;
                setInputData((prevData: any) => ({
                  ...prevData,
                  line_item_name: newName,
                }));
              }}
              defaultValue={inputData?.line_item_name || ""}
              className="lineItemInput"
              placeholder="Enter line item"
            />
          </h4>
        </div>
        <Card className="innerCard">
          <div className="innerCardBox">
            <p>Total cost:</p>
            <h3>
              <InputNumber
                controls={false}
                className="serviceLineInput"
                addonBefore="$"
                placeholder="0"
              />
            </h3>
          </div>
          <div className="innerCardBox">
            <p>Total price:</p>
            <h3>
              <InputNumber
                controls={false}
                className="serviceLineInput"
                addonBefore="$"
                placeholder="0"
              />
            </h3>
          </div>
          <div className="innerCardBox">
            <p>GM:</p>
            <h3>
              <InputNumber
                className="serviceLineInput"
                addonAfter={<span>%</span>}
                placeholder="0"
                controls={false}
                max={99}
                min={0}
              />
            </h3>
          </div>
        </Card>
      </div>
    </Card>
  );
}
